/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Recipient_HostingInputs */

const da_privacy_recipient_hosting = /** @type {(inputs: Privacy_Recipient_HostingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hosting af tjenesten og databasen.`)
};

/** @type {(inputs: Privacy_Recipient_HostingInputs) => LocalizedString} */
const en_privacy_recipient_hosting = da_privacy_recipient_hosting;

/**

* @param {Privacy_Recipient_HostingInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_recipient_hosting = /** @type {((inputs?: Privacy_Recipient_HostingInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Recipient_HostingInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_recipient_hosting(inputs)
	return /** @type {LocalizedString} */ ("Hosting af tjenesten og databasen.")
});